// src/components/Header.js
import React, { useState, useEffect } from 'react';
import './Header.css';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    const newMenuState = !menuOpen;
    setMenuOpen(newMenuState);
    
    if (newMenuState) {
      document.body.classList.add('menu-open', 'no-scroll');
    } else {
      document.body.classList.remove('menu-open', 'no-scroll');
    }
  };

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMenuOpen(false);
      document.body.classList.remove('menu-open', 'no-scroll');
    }
  };

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape' && menuOpen) {
        setMenuOpen(false);
        document.body.classList.remove('menu-open', 'no-scroll');
      }
    };

    window.addEventListener('keydown', handleEscape);
    return () => window.removeEventListener('keydown', handleEscape);
  }, [menuOpen]);

  return (
    <>
      <header className={`header-sidebar ${scrolled ? 'scrolled' : ''}`}>
        <div className="header-inner">
          <div className="logo-container">
            <img 
              src="logo.png" 
              alt="KyroTech Logo" 
              className="logo-main"
              onError={(e) => {
                e.target.style.display = 'none';
                const fallback = document.createElement('div');
                fallback.textContent = 'KYROTECH';
                fallback.style.cssText = 'color: #fff; font-weight: bold; font-size: 20px; transform: rotate(-90deg);';
                e.target.parentNode.appendChild(fallback);
              }}
            />
          </div>

          {/* Fixed: Removed the img tag that was causing duplicate icon */}
          <button className="menu-toggle" onClick={toggleMenu} aria-label="Toggle menu">
            <div className="menu-bars">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </button>

          <div className="header-contact">
            <p className="vertical-text">hello@kyrotech.in</p>
          </div>

          <div className="header-time">
            <p className="vertical-text">09:00 AM - 10:30 PM</p>
          </div>
        </div>
      </header>

      {/* Offcanvas Menu */}
      <div className={`offcanvas-menu ${menuOpen ? 'active' : ''}`}>
        <div className="offcanvas-inner">
          <div className="offcanvas-left">
            <div className="offcanvas-logo">
              <img 
                src="/logo.png" 
                alt="KyroTech Logo"
                onError={(e) => {
                  e.target.style.display = 'none';
                  const fallback = document.createElement('div');
                  fallback.textContent = 'KYROTECH';
                  fallback.style.cssText = 'color: #fff; font-weight: bold; font-size: 36px; margin-bottom: 20px;';
                  e.target.parentNode.appendChild(fallback);
                }}
              />
            </div>
            <div className="offcanvas-contact-info">
              <div className="info-item">
                <p className="info-label">Email</p>
                <a href="mailto:hello@kyrotech.in">hello@kyrotech.in</a>
              </div>
              <div className="info-item">
                <p className="info-label">Phone</p>
                <a href="tel:+91 8140320831">+91 8140320831</a>
              </div>
              <div className="info-item">
                <p className="info-label">Location</p>
                <span>E-1405 New ganesh glory, gota, 382481 Ahmedabad</span>
              </div>
            </div>
            <div className="offcanvas-footer">
              <p>© All rights reserved by KyroTech.in</p>
            </div>
          </div>

          <div className="offcanvas-right">
            <button className="close-button" onClick={toggleMenu} aria-label="Close menu">
              <span></span>
              <span></span>
            </button>

            <nav className="offcanvas-nav">
              <ul>
                <li><a onClick={() => scrollToSection('home')}>Home</a></li>
                <li><a onClick={() => scrollToSection('about')}>About Us</a></li>
                <li><a onClick={() => scrollToSection('services')}>Our Services</a></li>
                <li><a onClick={() => scrollToSection('portfolio')}>Portfolio</a></li>
                <li><a onClick={() => scrollToSection('contact')}>Contact Us</a></li>
              </ul>
            </nav>

            <div className="offcanvas-social">
              <span className="social-label">Follow Us</span>
              <div className="social-links">
                <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">Facebook</a>
                <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">Instagram</a>
                <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">LinkedIn</a>
                <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">Twitter</a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Overlay */}
      {menuOpen && <div className="offcanvas-overlay" onClick={toggleMenu}></div>}
    </>
  );
};

export default Header;